import React, { useState } from 'react';
import { Formik } from 'formik';
import { jobVaultIndexUrl } from 'buyside/util/urlHelper';
import { animateScroll } from 'react-scroll';

import Banner from 'buyside/components/presentation/Banner/banner';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import JobApplicationForm from 'buyside/components/presentation/JobApplicationsPage/JobApplicationForm/jobApplicationForm';
import {
  generateValidationSchema,
  getInitialFormValues
} from 'buyside/components/presentation/JobApplicationsPage/jobApplicationsPageHelpers';

import styles from './jobApplicationsPageStyles';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

const JobApplicationsPage = ({ createJobApplication, jobPost, loading, error, currentUser }) => {
  const [errors, setErrors] = useState(false);
  const isMobile = useIsMobile();

  const handleSubmit = (args, actions) => {
    const { email, phone, coverLetter } = args;

    const variables = {
      jobPostId: jobPost.id,
      phone,
      email,
      coverLetter
    };

    createJobApplication(variables)
      .then(() => {
        window.location.assign(jobVaultIndexUrl());
      })
      .catch(() => {
        setErrors(true);
        actions.setSubmitting(false);
        animateScroll.scrollToTop({ duration: 1000 });
      });
  };

  if (loading) {
    return <LoadingSpinner size="large" />;
  }

  if (error) throw error;

  const validationSchema = generateValidationSchema(jobPost);
  const initialValues = getInitialFormValues(currentUser);

  return (
    <div>
      {errors && (
        <div className={styles.banner}>
          <Banner error>
            There was a problem saving your job application. Please try again at a later time. If
            the problem persists, contact support@sumzero.com for assistance.
          </Banner>
        </div>
      )}

      <div className={styles.header}>Apply for this Job</div>

      <div className={`${isMobile ? '' : styles.responsiveContainer}`}>
        <p className={styles.subHeader}>
          Enter your contact details below. Make sure the information below is correct, as it will
          be presented directly to the hiring manager as a means to contact you if you are
          qualified.
        </p>

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          render={formikProps => (
            <JobApplicationForm jobPost={jobPost} currentUser={currentUser} {...formikProps} />
          )}
        />
      </div>
    </div>
  );
};

export default JobApplicationsPage;
